import React, { Component } from 'react'
import './App.css'
import PageContainer from './containers/PageContainer'
import PageResolutions from './hoc/PageResolutions'

class App extends Component {
  render () {
    return (
      <PageResolutions>
        <div className='App'>
          <PageContainer />
        </div>
      </PageResolutions>
    )
  }
}

export default App
